import React, { useState, useEffect } from "react";
import { Typography, TextField, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as yup from "yup";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { START_FORGOT_PASSWORD, RESET_STATE } from "Actions/AuthAction";
import { useNotification } from "Hooks/NotificationManager";
import { useNavigate } from "react-router-dom";
import "../../Sass/Auth.scss";
import Button from "Components/Common/Button/Button";

const useStyle = makeStyles((theme) => ({
  rsForgotForm: {
    width: "100%",
    "&>div": {
      marginBottom: "40px",
    },
    "&>button": {
      color: "#ffffff",
      fontSize: "18px",
      minWidth: "160px",
      minHeight: "50px",
      fontWeight: "bold",
      backgroundColor: " #3cb477",
      borderRadius: "8px",
      border: "none",
      boxShadow: "0px 7px #309562",
      padding: "0px 30px",
      display: "inline-flex",
      alignItems: " center",
      justifyContent: " center",
      "&:hover,&:active,&:focus-visible": {
        backgroundColor: "#2A7E54 !important",
        boxShadow: "0px 7px #309562",
      },
      [theme.breakpoints.down("500")]: {
        fontSize: "0.875rem",
      },
    },
  },
}));

const ForgotPassword = (props) => {
  const { dispatchForgotPassword, forgotPasswordDetail, dispatchResetState } =
    props;
  const classes = useStyle();
  const notification = useNotification();
  const navigate = useNavigate();
  const [isForgotProceed, setIsForgotProceed] = useState(false);

  /* Handle Send Email */
  const handleSendEmail = (data) => {
    setIsForgotProceed(true);
    const { email } = data;
    dispatchForgotPassword(email);
  };

  /* Forgot password validation schema */
  const forgotPasswordSchema = yup.object().shape({
    email: yup
      .string()
      .required("The email field is required.")
      .email("The email must be a valid email address."),
  });

  /* Formik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setFieldError,
    handleBlur,
  } = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: handleSendEmail,
    enableReinitialize: true,
  });

  /* Forgot password Success useffect */
  useEffect(() => {
    if (isForgotProceed) {
      if (!forgotPasswordDetail.success) {
        if (forgotPasswordDetail.errors.hasOwnProperty("email")) {
          setFieldError("email", forgotPasswordDetail.errors.email[0]);
        }
      } else {
        notification.success("Reset password link sent on your email id.");
        resetForm();
        dispatchResetState("forgotPasswordDetail", "");
        navigate("/login");
      }
      setIsForgotProceed(false);
    }
  }, [forgotPasswordDetail.success, forgotPasswordDetail.errors]);

  return (
    <Paper elevation={0} className="rsForgotPassword">
      <box className="rsBoxForgot">
        <div elevation={0} className="rsBoxForgotSubRoot">
          <box className="rsBoxForgotText">
            <Typography variant="h2" semiBold>
              Forgot password?
            </Typography>
            <Typography variant="h5" extraSmall>
              No problem. Just let us know your email address and we will email
              you a password reset link that will allow you to choose a new one
            </Typography>
          </box>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className={classes.rsForgotForm}
          >
            <TextField
              className="RsInput"
              secondary
              fullWidth
              name="email"
              type="text"
              placeholder="Email Address"
              autoComplete="email"
              autoFocus
              value={values.email}
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
              }}
              InputProps={{
                startAdornment: (
                  <>
                    {/* <InputAdornment position="start">
                      <PrimaryIcon width="20px" icon={EmailIcon} />
                    </InputAdornment>
                    <Divider className="rsInputDivider" /> */}
                  </>
                ),
              }}
              error={touched.email && errors.email}
              helperText={touched.email && errors.email}
              InputLabelProps={{ shrink: true }}
            />
            <Button
              children=" Email Password Reset Link"
              variant="contained"
              color="primary"
              disabled={forgotPasswordDetail?.isLoading}
              loading={forgotPasswordDetail?.isLoading}
              type="submit"
            />
          </form>
        </div>
      </box>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  forgotPasswordDetail: state.auth.forgotPasswordDetail,
});
const mapDispatchToProps = (dispatch) => ({
  dispatchForgotPassword: (email) =>
    dispatch({ type: START_FORGOT_PASSWORD, email }),
  dispatchResetState: (key, payload) =>
    dispatch({ type: RESET_STATE, key, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
